import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { CustomResponse } from '@ascschool/model/custom-response.model';
import { StudentLearningProcess } from '@ascschool/model/school/student-learning-process.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CourseService } from '@ascschool/services/school/course.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { ClassCourseCourseService } from '@ascschool/services/category/class-course.service';
import { StaffService } from '@ascschool/services/user/staff.service';
import { ResultService } from '@ascschool/services/category/result.service';
import { AchievementService } from '@ascschool/services/category/achievement.service';
import { ClassService } from '@ascschool/services/category/class.service';
import { ChuongTrinhHocService } from '@ascschool/services/category/chuong-trinh-hoc.service';
import { EducationalStatusService } from '@ascschool/services/category/educational-status.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';

@Component({
  selector: 'app-student-learning-process-add-popup',
  templateUrl: './student-learning-process-add-popup.component.html',
  styleUrls: ['./student-learning-process-add-popup.component.scss']
})
export class StudentLearningProcessAddPopupComponent implements OnInit {
  @Input() schoolId: any;
  @Input() dataTransmission: any;
  itemQTHT: StudentLearningProcess = new StudentLearningProcess();
  response: CustomResponse = new CustomResponse();

  getCourseACFn: (value: any) => Observable<any>;
  CourseSubscription: any;
  CourseControl = new FormControl();
  getSchoolACFn: (value: any) => Observable<any>;
  SchoolSubscription: any;
  SchoolControl = new FormControl();
  getStaffACFn: (value: any) => Observable<any>;
  StaffSubscription: any;
  StaffControl = new FormControl();
  getClassACFn: (value: any) => Observable<any>;
  ClassSubscription: any;
  ClassControl = new FormControl();
  getResultACFn: (value: any) => Observable<any>;
  ResultSubscription: any;
  ResultControl = new FormControl();
  getAchievementACFn: (value: any) => Observable<any>;
  AchievementSubscription: any;
  AchievementControl = new FormControl();
  getChuongTrinhHocACFn: (value: any) => Observable<any>;
  ChuongTrinhHocSubscription: any;
  ChuongTrinhHocControl = new FormControl();
  getCaDisEducationalStatusessACFn: (value: any) => Observable<any>;
  caDisEducationalStatusesSubscription: any;
  caDisEducationalStatusesControl = new FormControl();
  getDisSchoolLevelsACFn: (value: any) => Observable<any>;
  DisSchoolLevelsSubscription: any;
  DisSchoolLevelsControl = new FormControl();
  isEditMode = false;
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private courseService: CourseService,
    private schoolService : SchoolService,
    private classcourseService: ClassCourseCourseService,
    private staffService: StaffService,
    private resultService: ResultService,
    private achievementService: AchievementService,
    private chuongTrinhHocService : ChuongTrinhHocService,
    private caDisEducationalStatusesService: EducationalStatusService,
    private disSchoolLevelsService: SchoolLevelService,
  ) {
  }

  ngOnInit() {
    this.itemQTHT.schoolId = this.schoolId;

    if (this.dataTransmission) {
      this.setDataView(this.dataTransmission);
      this.itemQTHT = Object.assign({}, this.dataTransmission);
      this.CourseControl.setValue({ id: this.itemQTHT.courseId, text: this.itemQTHT.courseName });
      this.ResultControl.patchValue({ id: this.itemQTHT.resultId, text: this.itemQTHT.resultName });
    }

    this.schoolService.GetSelectPagingByUser().subscribe(res =>{
      this.SchoolControl.setValue({id: res.id , text: res.educationAndTrainingName});
      this.loadClass();
      this.loadStaff();

    });
    this.loadCourse();
    this.loadSchool();
    this.loadResult();
    this.loadAchievement();
    this.loadChuongTrinhHoc();
    this.loadCaDisEducationalStatuses();
    this.loadDisSchoolLevels();
  }
  setDataView(data: StudentLearningProcess){
    this.courseService.GetSelectPagingById(data.courseId).subscribe(res => {
      this.CourseControl.setValue({id: res.id , text: res.courseName});
    });
    this.schoolService.GetSelectPagingById(data.schoolId).subscribe(res =>{
      this.SchoolControl.setValue({id: res.id , text: res.educationAndTrainingName});
    });
    this.staffService.getById(data.managerId).subscribe(res =>{
      this.StaffControl.setValue({id: res.id , text: res.fullName});
    });
     this.resultService.getSelectPagingById(data.resultId).subscribe(res =>{
      this.ResultControl.setValue({id: res.id , text: res.resultName});
    });
    this.chuongTrinhHocService.getSelectPagingNoiSinhById(data.studyProgramId).subscribe(res =>{
      this.ChuongTrinhHocControl.setValue({id: res.id , text: res.ChuongTrinhHocName});
    });
    this.caDisEducationalStatusesService.getSelectById(data.schoolId).subscribe(res =>{
      this.caDisEducationalStatusesControl.setValue({id: res.id , text: res.name});
    });
    this.disSchoolLevelsService.getSelectPagingSchoolLevelsById(data.schoolLevelId).subscribe(res =>{
      this.DisSchoolLevelsControl.setValue({id: res.id , text: res.schoolLevelName});
    });
  }
  UpdateClose() {
    if (this.itemQTHT.courseId  && this.itemQTHT.educationalStatusId && this.itemQTHT.schoolId) {
      this.itemQTHT.courseName = this.CourseControl.value.text;
      this.itemQTHT.educationalStatusName = this.caDisEducationalStatusesControl.value.text;
      this.itemQTHT.schoolName = this.SchoolControl.value.text;
      if(this.StaffControl.value){
        this.itemQTHT.staffName = this.StaffControl.value.text;
      }
      if(this.ChuongTrinhHocControl.value){
        this.itemQTHT.chuongTrinhHocName = this.ChuongTrinhHocControl.value.text;
      }
      if(this.ResultControl.value){
        this.itemQTHT.resultName = this.ResultControl.value.text;
      }
      this.response.data = this.itemQTHT;
      this.response.status = true;
      this.modal.close(this.response);
      this.msg.success('Thành công');
    } else {
      this.msg.warning('Vui lòng nhập trường bắt buộc');
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(this.response);
  }

  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  onChange(result: Date[]): void {
    console.log('onChange: ', result);
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }
  loadCourse() {
    this.getCourseACFn = (value: any) => this.courseService.getEspCoursesSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.courseName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.CourseSubscription) this.CourseSubscription = this.CourseControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'courseId', this.CourseControl.value);
    });
  }
  changeCourse(control: FormControl) {
    this.CourseControl = control;
    if(this.CourseControl){
      this.loadClass();
    }
  }

  loadSchool() {
    this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SchoolSubscription) this.SchoolSubscription = this.SchoolControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'schoolId', this.SchoolControl.value);
    });
  }
  changeSchool(control: FormControl) {
    this.SchoolControl = control;
    if(this.SchoolControl){
      this.loadClass();
    }
  }

  loadClass() {
    this.getClassACFn = (value: any) => this.classcourseService.getClassCourseSelectPaging({ searchTerm: value,CourseId: this.valueIfHas(this.CourseControl),SchoolId: this.valueIfHas(this.SchoolControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.className + ' | ' + x.managerName,managerName: x.managerName , className : x.className})) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ClassSubscription) this.ClassSubscription = this.ClassControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'classCourseId', this.ClassControl.value);
    });
  }
  changeClass(control: FormControl) {
     this.ClassControl = control;
    // this.itemQTHT.managerName = control.value.managerName
  }

  loadStaff() {
    this.getStaffACFn = (value: any) => this.staffService.GetSelectPagingNhanSuThuocCoSo({SchoolId: this.schoolId ? this.schoolId : 0, searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.fullName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.StaffSubscription) this.StaffSubscription = this.StaffControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'managerId', this.StaffControl.value);
    });
  }
  changeStaff(control: FormControl) {
    this.StaffControl = control;
  }

  loadResult() {
    this.getResultACFn = (value: any) => this.resultService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.resultName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ResultSubscription) this.ResultSubscription = this.ResultControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'resultId', this.ResultControl.value);
    });
  }
  changeResult(control: FormControl) {
    this.ResultControl = control;
  }
  loadAchievement() {
    this.getAchievementACFn = (value: any) => this.achievementService.getAchievementSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.achievementName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.AchievementSubscription) this.AchievementSubscription = this.AchievementControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'achievementId', this.AchievementControl.value);
    });
  }
  changeAchievement(control: FormControl) {
    this.AchievementControl = control;
  }
  loadChuongTrinhHoc() {
    this.getChuongTrinhHocACFn = (value: any) => this.chuongTrinhHocService.getNoiSinhSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ChuongTrinhHocSubscription) this.ChuongTrinhHocSubscription = this.ChuongTrinhHocControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'studyProgramId', this.ChuongTrinhHocControl.value);
    });
  }
  changeChuongTrinhHoc(control: FormControl) {
    this.ChuongTrinhHocControl = control;
  }
  loadCaDisEducationalStatuses() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisEducationalStatusessACFn = (value: any) => this.caDisEducationalStatusesService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.caDisEducationalStatusesSubscription) { this.caDisEducationalStatusesSubscription = this.caDisEducationalStatusesControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'educationalStatusId', this.caDisEducationalStatusesControl.value);
    });
    }
  }
  changeCaDisEducationalStatuses(control: FormControl) {
    this.caDisEducationalStatusesControl = control;
  }
  loadDisSchoolLevels() {
    this.getDisSchoolLevelsACFn = (value: any) => this.disSchoolLevelsService.getSchoolLevelsSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.DisSchoolLevelsSubscription) { this.DisSchoolLevelsSubscription = this.DisSchoolLevelsControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.itemQTHT, 'schoolLevelId', this.DisSchoolLevelsControl.value);
    });
    }
  }
  changeDisSchoolLevels(control: FormControl) {
    this.DisSchoolLevelsControl = control;
  }
}
